import { createAuthenticator } from '@creditornot/wolt-auth';

import { errorReporter } from '../errorReporter';

import { authService } from './authService';
import { authStorage } from './authStorage';

export const authenticator = createAuthenticator({
  authService,
  storage: authStorage,
  logger: {
    logAction(action, authState) {
      const santiziedAuthState = {
        ...authState,
        user: authState.user ? authState.user.id : undefined,
      };

      errorReporter.leaveBreadcrumb(`Authenticator action: ${action}`, {
        metadata: {
          state: santiziedAuthState,
        },
      });
    },
    logMethod(method) {
      errorReporter.leaveBreadcrumb(`Authenticator method called: ${method}()`);
    },
  },
});

declare module '@creditornot/wolt-auth/react' {
  interface AuthContext {
    authenticator: typeof authenticator;
  }
}
